<div class="list-container" [loading]="loading">
  <table class="table">
    <thead>
      <tr>
        <th scope="col">Nom</th>
        <th scope="col"><i class="green fa-solid fa-pen-to-square"></i></th>
        <th scope="col"><i class="red fa-solid fa-trash"></i></th>
      </tr>
    </thead>
    <tbody class="table-group-divider">
      <tr *ngFor="let group of groups">
        <td>{{group.name}}</td>
        <td>
        	<a href="" [routerLink]="route.parse('group-set', [group.ident])"><i class="green fa-solid fa-pen-to-square"></i></a>
        </td>
        <td>
        	<a (click)="rm(group.ident)"><i class="red fa-solid fa-trash"></i></a>
        </td>
      </tr>
    </tbody>
  </table>
</div>